// Allow merchants to define store locations - SC-73531
export const STORE_LOCATIONS_BETA_FEATURE = 'checkout_store_locations'
